<template>
  <div class="text-center avatarPos">
    <v-col style="height: 100%;">
    
      <v-row>
         <div style="width: 100%" class="text-center avatarPos">
           <v-avatar width="54px" height="54px">
           <img class="fitImage" v-bind:src="userImage" v-on:click="handleImage"/>
         </v-avatar>
         </div>
      </v-row>
      
      <p class="leaveType mt-1">{{getType().typeName}}</p>
      <p class="reason mt-n2">{{getType().reasonName}}</p>
      <p v-if="!VacationData.VacationData.all_day" >{{ $t("register_vacation_all_day") }}</p>
      <p v-else-if="VacationData.VacationData.all_day && this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) == this.getStringDateFromDateTime(this.VacationData.VacationData.to_date)" class="mt-n2">{{ this.getStringDateFromDateTime(this.VacationData.VacationData.to_date) }}</p>
      <p style="height: 10px" v-else ></p>
      <div style="margin-top: -11px; height: auto" v-if="!VacationData.VacationData.all_day && this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) == this.getStringDateFromDateTime(this.VacationData.VacationData.to_date)">
        <div class="Time allDay" style="text-align: center; padding-top: 10px; background-color: #F4F4F4;">
            <div class="footer content">
                <v-avatar style="margin-left: -10px;" width="19px" height="19px">
                  <img src="@/assets/time.png" />
                </v-avatar>
                <span  style="font-size: 14px; margin-left: -10px;"> {{getFromDateTime}}</span>
            </div>
         </div>
      </div>
      <div style="margin-top: -11px; height: 200px" v-else>
           <div class="Time" style="text-align: center; padding-top: 10px; background-color: #F4F4F4; height: auto; padding-bottom: 08px">
             <div class="footer content">
                <v-avatar style="margin-left: -10px;"  width="19px" height="19px">
                  <img src="@/assets/time.png" />
                </v-avatar>
                <span style="font-size: 14px; margin-left: -10px;"> 
                  {{getFromDateTime}}
                </span>
             </div>
        </div>
        <div class="Time" style="text-align: center; padding-top: 10px; background-color: #E9E9E9; height: auto; padding-bottom: 08px">
             <div class="footer content">
                <v-avatar style="margin-left: -10px;" width="19px" height="19px">
                  <img src="@/assets/time.png" />
                </v-avatar>
             <span style="font-size: 14px; margin-left: -10px; "> 
                 {{getToDateTime}}
             </span>
            </div>
        </div>
      </div>            
    </v-col>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import moment from 'moment';
import { DefaultValues, ListEvents } from "@/utilities/CommonUtilities";
    export default {
      name :'HeaderVacation',
        props:{
          VacationData: Object
        },
        data () {
            return {
                isAllDay: false,
            }
        },
        computed: {
          ...mapGetters(["getUserByID"]),
          ...mapGetters(["getReasonByID"]),
          ...mapState(["listReason"]),
          ...mapState(["userInfo"]),
          ...mapGetters(["getTypeAndReasonByReasonID"]),
          getFromDateTime(){
            if(!this.VacationData.VacationData.all_day && (this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) != this.getStringDateFromDateTime(this.VacationData.VacationData.to_date))){
              return this.getStringDateFromDateTime(this.VacationData.VacationData.from_date);
            }
            else if(!this.VacationData.VacationData.all_day && (this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) == this.getStringDateFromDateTime(this.VacationData.VacationData.to_date))){
              return this.getStringDateFromDateTime(this.VacationData.VacationData.from_date);
            }
            else if(this.VacationData.VacationData.all_day && this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) != this.getStringDateFromDateTime(this.VacationData.VacationData.to_date)){
              return this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) + " (" + this.getStringTimeFromDateTime(this.VacationData.VacationData.from_date) +")";
            }else if(this.VacationData.VacationData.all_day && this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) == this.getStringDateFromDateTime(this.VacationData.VacationData.to_date)){
              return this.getStringTimeFromDateTime(this.VacationData.VacationData.from_date);
            }
            return null
        },
        getToDateTime(){
          if(!this.VacationData.VacationData.all_day && (this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) != this.getStringDateFromDateTime(this.VacationData.VacationData.to_date))){
            return this.getStringDateFromDateTime(this.VacationData.VacationData.to_date);
          }else if(this.VacationData.VacationData.all_day && this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) != this.getStringDateFromDateTime(this.VacationData.VacationData.to_date)){
            return this.getStringDateFromDateTime(this.VacationData.VacationData.to_date) + " (" + this.getStringTimeFromDateTime(this.VacationData.VacationData.to_date) +")";
          }else if(this.VacationData.VacationData.all_day && this.getStringDateFromDateTime(this.VacationData.VacationData.from_date) == this.getStringDateFromDateTime(this.VacationData.VacationData.to_date)){
            return this.getStringTimeFromDateTime(this.VacationData.VacationData.to_date);
          }
          return null
        },
        userImage() {
          if (this.VacationData.userInfomation && this.VacationData.userInfomation.profiolePhoto != null) {
            return `data:image/png;base64,${this.VacationData.userInfomation.profiolePhoto}`;
         } else {
            return DefaultValues.no_image;
         }
    },
      },
      methods: {
        getStringTimeFromDateTime(frromDate) {
          return moment(String(frromDate)).format('HH:mm')
        },
        getStringDateFromDateTime(frromDate) {
          return moment(String(frromDate)).format('YYYY/MM/DD')
        },
        closeDetail() {
        this.notifyBus.$emit(ListEvents.closeVacationDetail);
      },
      getType() {
        let typeName1 = "";
        let reasonName1 = "";
        let listType = this.getTypeAndReasonByReasonID(this.VacationData.VacationData.reason_id);
         if(this.$i18n.locale == 'ja') {
           typeName1 = listType.type.name_jp
           reasonName1 = listType.reason.name_jp;
         } else if(this.$i18n.locale == 'vi') {
           typeName1 = listType.type.name_vi
           reasonName1 = listType.reason.name_vi;
         } else {
           typeName1 = listType.type.name_en
           reasonName1 = listType.reason.name_en;
        }
        return {typeName: typeName1, reasonName: reasonName1};
       },
       handleImage() {
             this.$router.push('/profile/'+this.VacationData.VacationData.user_id);
             this.notifyBus.$emit(ListEvents.closeVacationDetail);
       }
      },
      
      inject: ["notifyBus"],
     
    }
</script>
<style scoped>
  .leaveType{
    font-size: 14px;
    font-weight: bold
  }
  .reason{
    font-size: 14px
  }
  .Time{
    width: 50%;
    float: left;
    height: 50px
  }
  .allDay{
    width: 100%;
  }
  .fitImage {
    object-fit: cover;
    cursor:pointer;
}

</style>
